export default "__VITE_ASSET__B7_XF$6w__"